export default "__VITE_ASSET__22a65200__"